import {
  Card,
  CardBody,
  CardDescription,
  CardHeader,
  CardTitle,
  Code,
} from '@apollo/orbit';
import React from 'react';

import { ampli } from 'src/lib/analytics/amplitude/vendor';

export const RoverCallToAction = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle size="lg" as="h4">
          I'm starting from scratch
        </CardTitle>
        <CardDescription>
          Create a graph with a single interactive command. From an empty
          directory, run:
        </CardDescription>
      </CardHeader>
      <CardBody className="flex flex-grow flex-col justify-end">
        <Code
          canCopy
          onClick={() => {
            ampli.cliCommandCopied({
              CommandType: 'Onboarding',
              CommandContent: 'rover init',
              Location: 'ZeroState',
            });
          }}
          className="h-12 w-full justify-between p-3"
        >
          rover init
        </Code>
      </CardBody>
    </Card>
  );
};
